import { useState } from "react";
import { C } from "../../styles/theme";

export default function WABtn({ num }) {
  const [open, setOpen] = useState(false);
  const clean = (num || "917977779135").replace(/\D/g, "");
  return (
    <div className="wa-btn" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10 }}>
      {open && (
        <div style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 8px 28px rgba(0,0,0,.18)", width: 230, animation: "slidein .22s ease", border: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.dark, marginBottom: 5 }}>Chat with us on WhatsApp</div>
          <div style={{ fontSize: 12, color: C.gray, marginBottom: 11, lineHeight: 1.55 }}>We typically reply within minutes.</div>
          <a href={"https://wa.me/" + clean + "?text=Hello%20Cyclojet%20Infotech%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."} target="_blank" rel="noreferrer"
            style={{ display: "block", background: "#25D366", color: "#fff", textDecoration: "none", padding: "9px 14px", borderRadius: 8, fontWeight: 700, fontSize: 13, textAlign: "center" }}>
            Open WhatsApp Chat
          </a>
        </div>
      )}
      <button onClick={() => setOpen(o => !o)} style={{ width: 52, height: 52, borderRadius: "50%", background: "#25D366", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, boxShadow: "0 5px 20px rgba(37,211,102,.45)", animation: "wa 2.5s ease-in-out infinite" }}>
        {open ? "x" : "💬"}
      </button>
    </div>
  );
}
